import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  CanActivateChild
} from '@angular/router';

import { Observable } from 'rxjs';
import { AppService, UserService } from '../service/user.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogin(state.url);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogin(state.url);
  }

  private checkLogin(url: string): true | UrlTree {
    const token = AppService.get(AppService.KEY.MOQUI_SESSION_TOKEN);
    if (token) {
      UserService.set(UserService.KEY.ROUTER_STATE, url);
      return true;
    }
    if (url.startsWith('/login') || url.startsWith('/callback-auth')) {
      return true;
    }
    UserService.set(UserService.KEY.ROUTER_STATE, url);
    return this.router.createUrlTree(['/login']);
  }
}
